import React, { useState } from 'react';
import { TourDetailPage } from './pages/TourDetailPage';
import { CountryPage } from './pages/CountryPage';
import { TravelClubPage } from './pages/TravelClubPage';
export function App() {
  // Simple routing state to handle navigation
  const [currentPage, setCurrentPage] = useState('country');
  const [currentTourId, setCurrentTourId] = useState<string | null>(null);
  // Function to handle navigation to tour detail page
  const handleNavigateToTour = (tourId: string) => {
    setCurrentTourId(tourId);
    setCurrentPage('tourDetail');
  };
  // Function to navigate back to country page
  const handleNavigateToCountry = () => {
    setCurrentPage('country');
    setCurrentTourId(null);
  };
  // Function to navigate to travel club page
  const handleNavigateToTravelClub = () => {
    setCurrentPage('travelClub');
  };
  // Expose navigation functions through window for components to use
  if (typeof window !== 'undefined') {
    window.navigateToTour = handleNavigateToTour;
    window.navigateToCountry = handleNavigateToCountry;
    window.navigateToTravelClub = handleNavigateToTravelClub;
  }
  // Render the appropriate page based on current state
  if (currentPage === 'tourDetail') {
    return <TourDetailPage tourId={currentTourId} onBack={handleNavigateToCountry} data-id="element-0" />;
  } else if (currentPage === 'travelClub') {
    return <TravelClubPage onBack={handleNavigateToCountry} data-id="element-1" />;
  } else {
    return <CountryPage onTourClick={handleNavigateToTour} data-id="element-2" />;
  }
}
// Add type definitions for window object
declare global {
  interface Window {
    navigateToTour: (tourId: string) => void;
    navigateToCountry: () => void;
    navigateToTravelClub: () => void;
  }
}